import React from 'react';
import DeleteMenuIcon from '../../assets/DeleteMenuIcon';
import EditPencil from '../../assets/EditPencil';

export const rnpMenuList = [
  {
    name: 'Edit RNP',
    icon: <EditPencil fontSize="small" color="#667085" />,
  },
  {
    name: 'Delete RNP',
    icon: <DeleteMenuIcon fontSize="small" />,
  },
];
